/**
 * Shared helpers for the cart drawer's upsells on fanola.hair: the minicart card
 * (snippets/cart-drawer.liquid) and the developer pop-out (assets/cart-dev-popout.js).
 * Pure functions plus one cached fetch; tests load this file in a VM
 * (tests/upsell-kit.test.mjs).
 */
(function () {
  'use strict';

  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) {
    return String(s === null || s === undefined ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; });
  }

  function money(pence) { return '£' + (Number(pence) / 100).toFixed(2); }

  /**
   * Most of one variant a shopper can still add: stock minus what is already in the basket.
   * stock null/undefined = untracked or oversellable -> uncapped (99).
   */
  function capFor(stock, inCart) {
    if (stock === null || stock === undefined) return 99;
    return Math.max(0, Math.min(99, Number(stock) - (Number(inCart) || 0)));
  }

  function clampQty(q, delta, max) { return Math.max(1, Math.min(max, (Number(q) || 1) + delta)); }

  function parseStock(html) {
    var m = /data-variant-stock>([^<]*)</.exec(html || '');
    if (!m) return {};
    try { var o = JSON.parse(m[1]); return (o && typeof o === 'object') ? o : {}; } catch (e) { return {}; }
  }

  var stockCache = {};
  /** sections/api-variant-stock.liquid for one product. Never rejects: failure = {} = uncapped. */
  function fetchStock(handle) {
    return stockCache[handle] || (stockCache[handle] =
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=api-variant-stock', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(parseStock)
        .catch(function () { return {}; }));
  }

  function shortName(names, handle, title) {
    var n = names && handle ? names[handle] : null;
    return (typeof n === 'string' && n) ? n : (title || '');
  }

  /** Quantity stepper markup. ns namespaces classes + data attributes (dvp = pop-out, upq = card). */
  function stepperHtml(ns, key, q, max) {
    var k = esc(key);
    return '<div class="' + ns + '__qty" role="group" aria-label="Quantity">' +
      '<button type="button" class="' + ns + '__qb" data-' + ns + '-dec="' + k + '" aria-label="Fewer"' + (q <= 1 ? ' disabled' : '') + '>−</button>' +
      '<span class="' + ns + '__qn" data-' + ns + '-q="' + k + '" aria-live="polite">' + q + '</span>' +
      '<button type="button" class="' + ns + '__qb" data-' + ns + '-inc="' + k + '" aria-label="More"' +
      (q >= max ? ' disabled' + (max < 99 ? ' title="Only ' + max + ' available"' : '') : '') + '>+</button></div>';
  }

  /** Update one stepper in place (no redraw, so focus and layout never move). */
  function syncStepper(root, ns, key, q, max) {
    if (!root) return;
    var n = root.querySelector('[data-' + ns + '-q="' + key + '"]');
    if (n) { var t = n.firstChild; if (t && t.nodeType === 3) t.nodeValue = String(q); else n.textContent = String(q); } // text-node write = characterData, not childList (drawer observers)
    var dec = root.querySelector('[data-' + ns + '-dec="' + key + '"]');
    var inc = root.querySelector('[data-' + ns + '-inc="' + key + '"]');
    if (dec) dec.disabled = q <= 1;
    if (inc) { inc.disabled = q >= max; inc.title = (q >= max && max < 99) ? 'Only ' + max + ' available' : ''; }
  }

  window.UpsellKit = { esc: esc, money: money, capFor: capFor, clampQty: clampQty, parseStock: parseStock,
                       fetchStock: fetchStock, shortName: shortName, stepperHtml: stepperHtml, syncStepper: syncStepper };
})();
